import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const expiredInsuranceSlice = createSlice({
  name: "expiredInsurance",

  initialState: { expiredInsurance: [], expiredInsuranceLoader: false },
  reducers: {
    setExpiredInsuranceList: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.expiredInsurance = payload;
    },
    setExpiredInsuranceListLoader: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.expiredInsuranceLoader = payload;
    },
    resetExpiredInsuranceList: (state) => {
      state.expiredInsurance = [];
    },
  },
});

export const {
  setExpiredInsuranceList,
  resetExpiredInsuranceList,
  setExpiredInsuranceListLoader,
} = expiredInsuranceSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default expiredInsuranceSlice.reducer;
